export const locales_mixin = {
    methods: {
        translate(locale_key, params = null) {
            return this.$t(locale_key, params)
        },
        format_as_currency(number, currency, digits = 0) {
            if (number === undefined || number === null) return number
            if (Math.abs(number) < 0.0000001) number = 0

            currency = currency || 'SEK'
            return new Intl.NumberFormat(this.$i18n.locale, {
                style: 'currency',
                currency: currency,
                minimumFractionDigits: digits,
                maximumFractionDigits: digits,
            }).format(number)
        },
    },
}
